import React, { useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { initialSettings } from "../../core/common/selectoption/selectoption";
import CollapseHeader from "../../core/common/collapse-header";

import { paymentsData } from "../../core/data/json/payment-list";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import Table from "../../core/common/dataTable/index";
import { all_routes } from "../router/all_routes";

const Recharge = () => {
  const route = all_routes;
  const data = paymentsData;
  const [adduser, setAdduser] = useState(false);
  const togglePopup = (isEditing: any) => {
    setAdduser(!adduser);
  };
  const columns = [
    {
      title: "InvoiceID",
      dataIndex: "invoiceId",
      key: "invoiceId",
      sorter: true,
    },
    {
      title: "Client",
      dataIndex: "client",
      key: "client",
      sorter: true,
      render: (text: any, record: any) => (
        <h2 className="table-avatar d-flex align-items-center">
          <Link
            to={route.companyDetails}
            className="avatar avatar-sm border me-2"
          >
            <ImageWithBasePath
              className="w-auto h-auto"
              src={record.client_img}
              alt="User Image"
            />
          </Link>
          <Link
            to={route.companyDetails}
            className="profile-split d-flex flex-column"
          >
            {record.client}
          </Link>
        </h2>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      sorter: true,
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      sorter: true,
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      key: "transactionId",
      sorter: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item edit-popup"
              to="#"
              onClick={() => togglePopup(false)}
            >
              <i className="ti ti-eye text-indigo" /> Preview
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_payments"
            >
              <i className="ti ti-trash text-danger" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Payments<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                        <h4>Add Balance</h4>
                      </div>
                      <div className="col-sm-8"></div>
                    </div>
                    {/* /Search */}
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-7">
                        <div className="box-body">
                          <div className="row">
                            <div className="col-lg-12 col-md-6 col-12">
                              <div className="row mb-3">
                                <div className="form-group">
                                  <label className="form-label">
                                    Select Card
                                  </label>
                                  <div className="input-group">
                              
                                    <select
                                      id="payment_method"
                                      name="payment_method"
                                      className="form-select"
                                    >
                                      <option value="0">Add New</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="col-md-6 form-group showOnlyOnNewCard ">
                                  <label className="form-label">
                                    Card Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="controls">
                                    <div className="input-group">
                                      
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Card Number"
                                        name="number"
                                        id=""
                                        data-validation-containsnumber-regex="(\d)+"
                                        data-validation-containsnumber-message="No Characters Allowed, Only Numbers"
                                      />
                                    </div>
                                    <div className="help-block"></div>
                                  </div>
                                </div>
                                <div className="col-md-6 form-group showOnlyOnNewCard">
                                  <label className="form-label">
                                    Card Holder Name
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group">
                                    
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      id="name"
                                      placeholder="Card Holder Name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="col-md-4 form-group showOnlyOnNewCard">
                                  <label className="form-label">
                                    Ex. Month
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group">
                                    <select
                                      id="exp_month"
                                      name="exp_month"
                                      className="form-select"
                                    >
                                      <option value="-">--</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                    </select>{" "}
                                  </div>
                                </div>
                                <div className="col-md-4 form-group showOnlyOnNewCard">
                                  <label className="form-label">
                                    Ex. Year
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group">
                                    <select
                                      id="exp_year"
                                      name="exp_year"
                                      className="form-select"
                                    >
                                      <option value="-">--</option>
                                      <option value="2025">2025</option>
                                      <option value="2026">2026</option>
                                      <option value="2027">2027</option>
                                      <option value="2028">2028</option>
                                      <option value="2029">2029</option>
                                      <option value="2030">2030</option>
                                      <option value="2031">2031</option>
                                      <option value="2032">2032</option>
                                      <option value="2033">2033</option>
                                      <option value="2034">2034</option>
                                      <option value="2035">2035</option>
                                      <option value="2036">2036</option>
                                      <option value="2037">2037</option>
                                      <option value="2038">2038</option>
                                      <option value="2039">2039</option>
                                      <option value="2040">2040</option>
                                      <option value="2041">2041</option>
                                      <option value="2042">2042</option>
                                      <option value="2043">2043</option>
                                      <option value="2044">2044</option>
                                      <option value="2045">2045</option>
                                    </select>{" "}
                                  </div>
                                </div>
                                <div className="col-md-4 form-group showOnlyOnNewCard">
                                  <label className="form-label">
                                    CVV<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="controls">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="cvc"
                                      placeholder="CVV"
                                      id="cvc"
                                      data-validation-containsnumber-regex="(\d)+"
                                      data-validation-containsnumber-message="No Characters Allowed, Only Numbers"
                                    />{" "}
                                    <div className="help-block"></div>
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="form-group">
                                  <label className="form-label">
                                    Amount
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="controls">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="amount"
                                      id="amount"
                                      placeholder="100"
                                      data-validation-containsnumber-regex="(\d)+"
                                      data-validation-containsnumber-message="No Characters Allowed, Only Numbers"
                                    />
                                    <div className="help-block"></div>
                                  </div>
                                </div>
                              </div>

                              <div className="row mb-3">
                                <div className="col-12">
                                  <span
                                    className="showOnlyOnNewCard"
                                    style={{ color: "red" }}
                                  >
                                    <b>
                                      Card information will be automatically
                                      saved for auto refill
                                    </b>
                                  </span>
                                  <input
                                    type="hidden"
                                    className="form-control"
                                    name="request_type"
                                    value="recharge"
                                  />
                                 
                                  <h2>
                                    <i className="fa fa-cc-visa text-info"></i>
                                    <i className="fa fa-cc-mastercard text-danger"></i>
                                    <i className="fa fa-cc-discover text-success"></i>
                                    <i className="fa fa-cc-amex text-warning"></i>
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="box-body">
                          <div className="row">
                            <div className=" form-group col-sm-6">
                              <label className="form-label">
                                Address<span style={{ color: "red" }}>*</span>{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control address_info"
                                name="line1"
                                value=""
                                id="line1"
                                placeholder="Address"
                              />
                              <span id="message"></span>
                            </div>
                            <div className="form-group col-sm-6 mb-3">
                              <label className="form-label">
                                Country<span style={{ color: "red" }}>*</span>{" "}
                              </label>
                              <select
                                className="form-select address_info"
                                name="country"
                                id="country"
                              >
                                <option>select country</option>
                                <option value="CA">Canada</option>
                                <option value="US">United States</option>
                              </select>
                            </div>
                            <div className="form-group col-sm-6">
                              <label className="form-label">
                                State <span style={{ color: "red" }}>*</span>
                              </label>
                              <span id="state-code">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="state"
                                />
                              </span>
                            </div>
                            <div className="form-group col-sm-6 mb-3">
                              <label className="form-label">
                                City<span style={{ color: "red" }}>*</span>{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control address_info"
                                name="city"
                                value=""
                                id="city"
                                placeholder="City"
                              />
                            </div>
                            <div className="form-group col-sm-6">
                              <label className="form-label">
                                ZIP <span style={{ color: "red" }}>*</span>{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control address_info"
                                name="postal_code"
                                value=""
                                id="postal_code"
                                placeholder="Zip"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                    <div className="d-flex align-items-center justify-content-end">
                <button type="button" className="btn btn-primary me-2">
                  Make Payment
                </button>
                
              </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
      <>
       
        {/* Add Company */}
        <div
          className="offcanvas  "
          style={{ width: "1250px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_add"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Add Payment Method</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row">
                <div className="col-md-12">
                  <h4 className="box-title mb-4 ">Billing Info</h4>
                  <div className="box-body">
                    <div className="row">
                      <div className="col-lg-12 col-md-6 col-12">
                        <div className="row">
                          <div className="form-group col-sm-6">
                            <label className="form-label">
                              Card Holder Name{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value=""
                              id="name"
                              placeholder="Card Holder Name"
                            />
                          </div>
                          <div className="form-group col-sm-6 mb-2">
                            <label className="form-label">
                              Card Number{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                            </label>
                            <div className="controls">
                              <input
                                type="text"
                                className="form-control"
                                name="number"
                                value=""
                                id=""
                                placeholder="Card Number"
                                data-validation-containsnumber-regex="(\d)+"
                                data-validation-containsnumber-message="No Characters Allowed, Only Numbers"
                              />
                              <div className="help-block"></div>
                            </div>
                          </div>
                          <div className="form-group col-sm-6">
                            <label className="form-label">
                              Ex. Month <span style={{ color: "red" }}>*</span>{" "}
                            </label>
                            <select
                              id="exp_month"
                              name="exp_month"
                              className="form-select"
                            >
                              <option value="-">--</option>
                              <option value="01">01</option>
                              <option value="02">02</option>
                              <option value="03">03</option>
                              <option value="04">04</option>
                              <option value="05">05</option>
                              <option value="06">06</option>
                              <option value="07">07</option>
                              <option value="08">08</option>
                              <option value="09">09</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                          </div>
                          <div className="form-group col-sm-6 mb-2">
                            <label className="form-label">
                              Ex. Year<span style={{ color: "red" }}>*</span>{" "}
                            </label>
                            <select
                              id="exp_year"
                              name="exp_year"
                              className="form-select"
                            >
                              <option value="-">----</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                              <option value="2027">2027</option>
                              <option value="2028">2028</option>
                              <option value="2029">2029</option>
                              <option value="2030">2030</option>
                              <option value="2031">2031</option>
                              <option value="2032">2032</option>
                              <option value="2033">2033</option>
                              <option value="2034">2034</option>
                              <option value="2035">2035</option>
                              <option value="2036">2036</option>
                              <option value="2037">2037</option>
                              <option value="2038">2038</option>
                              <option value="2039">2039</option>
                              <option value="2040">2040</option>
                              <option value="2041">2041</option>
                              <option value="2042">2042</option>
                              <option value="2043">2043</option>
                              <option value="2044">2044</option>
                              <option value="2045">2045</option>
                            </select>
                          </div>
                          <div className="form-group col-sm-6">
                            <div className="form-group ">
                              <label className="form-label">
                                CVV<span style={{ color: "red" }}>*</span>{" "}
                              </label>
                              <div className="controls">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="cvc"
                                  placeholder="CVV"
                                  id="cvc"
                                  data-validation-containsnumber-regex="(\d)+"
                                  data-validation-containsnumber-message="No Characters Allowed, Only Numbers"
                                />
                                <div className="help-block"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <h4 className="box-title mb-4 mt-4">Payment Method </h4>
                  <div className="box-body">
                    <div className="row">
                      <div className=" form-group col-sm-6">
                        <label className="form-label">
                          Address<span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control address_info"
                          name="line1"
                          value=""
                          id="line1"
                          placeholder="Address"
                        />
                        <span id="message"></span>
                      </div>
                      <div className="form-group col-sm-6 mb-2">
                        <label className="form-label">
                          Country<span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <select
                          className="form-select address_info"
                          name="country"
                          id="country"
                        >
                          <option>select country</option>
                          <option value="CA">Canada</option>
                          <option value="US">United States</option>
                        </select>
                      </div>
                      <div className="form-group col-sm-6">
                        <label className="form-label">
                          State <span style={{ color: "red" }}>*</span>
                        </label>
                        <span id="state-code">
                          <input
                            type="text"
                            className="form-control"
                            id="state"
                          />
                        </span>
                      </div>
                      <div className="form-group col-sm-6 mb-2">
                        <label className="form-label">
                          City<span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control address_info"
                          name="city"
                          value=""
                          id="city"
                          placeholder="City"
                        />
                      </div>
                      <div className="form-group col-sm-6">
                        <label className="form-label">
                          ZIP <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control address_info"
                          name="postal_code"
                          value=""
                          id="postal_code"
                          placeholder="Zip"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <h4 className="box-title mt-4 mb-4">General Info</h4>
                  <h2>
                    <i className="fa FaCcVisa text-info"></i>
                    <i className="fa fa-cc-mastercard text-danger"></i>
                    <i className="fa-cc-discover text-success"></i>
                    <i className=" fa-cc-amex text-warning"></i>
                  </h2>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button type="button" className="btn btn-primary me-2">
                  Save
                </button>
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Add Company */}
        {/* Delete Invoices */}
        <div className="modal fade" id="delete_payments" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Invoice?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> invoice you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger">
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Invoices */}
      </>
    </div>
  );
};

export default Recharge;
